import {ApplicationBody, ApplicationStatus} from '../domain/onBoarding/application-body';
import {IReferral} from '../domain/onBoarding/IReferral';
import {ICipQuestions} from '../domain/onBoarding/ICipQuestions';
import {LivenessPassiveTestResult} from '../domain/onBoarding/liveness-passive-test-result';

export class ApplicationBodyEntity implements ApplicationBody {
  platform: string;
  referrals: IReferral[];
  cipQuestions: ICipQuestions[];
  socialSecurityNumber: string | null;
  addressExteriorNumber: string;
  addressInteriorNumber: string;
  applicationId: number;
  applicationRejected: boolean;
  birthday: string;
  birthplace: string | null;
  birthplaceName: string | null;
  altairParentAgentId: number;
  cardHolderAgreement: boolean;
  cellphone: string;
  citizenshipCountry: string;
  citizenshipId: number;
  city: string;
  country: string;
  deviceIdentifier: string;
  documents: any;
  driverLicenseNumber: string;
  email: string;
  emissionDate: string;
  expirationDate: string;
  firstName: string | null;
  additionalNames: string | null;
  lastName: string | null;
  secondLastName: string | null;
  gender: string | null;
  ocrFirstName?: string | null;
  ocrAdditionalNames?: string | null;
  ocrLastName?: string | null;
  ocrSecondLastName?: string | null;
  ocrDateOfBirth?: string | null;
  ocrGender?: string | null;
  ocrFieldsConfirm?: boolean | null;
  ocrBirthplaceName?: string | null;
  ocrBirthplace: string | null;
  fiscalIdentifier: string;
  hasDriverLicenseNumber: boolean;
  hasSocialSecurityNumber: boolean;
  idCity: number;
  idConsent: boolean;
  idNumber: string;
  idState: string;
  idType: string;
  identification2Country: string;
  identification2Type: string;
  identificationCountry: string;
  identificationEmissionDate: number;
  identificationExpirationDate: number;
  identificationNumber: string;
  identificationType: string;
  ipAddress: string;
  kycStatus: string;
  locale: string;
  matchingPassword: string;
  password: string;
  phoneCountryCode: string;
  postalCode: number;
  privacyAdvice: boolean;
  publicityConsent: boolean;
  rejectedAppToken: string;
  securityAnswer: string;
  securityQuestionAnswer: string;
  securityQuestionKey: string;
  shortFormAgreement: boolean;
  latitude: number | null;
  longitude: number | null;
  state: string;
  status: ApplicationStatus;
  street: string;
  termNCond: boolean;
  pronoun: string;
  livenessPassiveTestResult: LivenessPassiveTestResult;
  externalReferenceCode: string | null;
  agentMode: string | null;
  suspicious: boolean | null;
  applicationHash: string | null;

  constructor() {
    this.platform = 'WEB';
    this.referrals = [];
    this.cipQuestions = [];
    this.socialSecurityNumber = null;
    this.firstName = null;
    this.additionalNames = null;
    this.lastName = null;
    this.secondLastName = null;
    this.gender = null;
    this.ocrFirstName = null;
    this.ocrAdditionalNames = null;
    this.ocrLastName = null;
    this.ocrSecondLastName = null;
    this.ocrDateOfBirth = null;
    this.ocrGender = null;
    this.ocrFieldsConfirm = null;
  }
}
